import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null
};

const checklistsSlices = createSlice({
  name: "checklists",
  initialState,
  reducers: {
    changeStatusChecklists: (state, action) => {
      const { status } = action.payload;
      state.status = status ? status : null;
    }
  }
});

export const { changeStatusChecklists } = checklistsSlices.actions;

export default checklistsSlices.reducer;
